import { ref } from "vue";

export const isCookieConsentBannerActive = ref(false);

export default {
  isCookieConsentBannerActive
};
